<template>
  <div class="protocol">
    <div class="protocol-font">{{ protocol.title }}</div>
    <div class="protocol-content">
      <div class="text" v-html="protocol.content"></div>
    </div>
  </div>
</template>

<script>
import { post } from "../../util/http";
export default {
  data() {
    return {
      protocol: {},
    };
  },

  created() {
    this.contentsView();
  },
  methods: {
    contentsView() {
      post({
        url: "/api/announcement/getAnnouncement",
        data: {
          id: parseInt(this.$route.params.id),
        },
      }).then(({ data: { data } }) => {
        console.log("---->>>>", data);
        this.protocol = data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.protocol {
  width: 1232px;
  margin: 0 auto;
  margin-top: 72px;
  margin-bottom: 16px;
  background: #ffffff;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 40px;

  .protocol-font {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    line-height: 50px;
  }

  .protocol-content {
    width: 100%;
    padding: 24px 80px 0;
    color: #333333;
    font-size: 15px;
    line-height: 22px;

    .text:nth-last-child(3) {
      text-align: right;
    }

    .title {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      line-height: 22px;
    }
  }
}
</style>
